import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dataForm" }
const _hoisted_2 = { class: "underlineForm" }
const _hoisted_3 = {
  key: 0,
  class: "mb-20 fullWidth"
}
const _hoisted_4 = {
  key: 0,
  class: "dialog-footer mt-20"
}
const _hoisted_5 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_MaterialDialog = _resolveComponent("MaterialDialog")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "dataForm",
      model: _ctx.ruleForm,
      rules: _ctx.rules,
      "label-position": "top",
      "label-width": "100px",
      class: "mb-20",
      disabled: _ctx.mode === 'approval'
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.mode !== 'approval' && !_ctx.isEdit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_el_button, {
                  onClick: _ctx.handleAddComand,
                  type: "primary"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" 添加材料 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, { onClick: _ctx.handleRemove }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode(" 移除材料 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table, {
            data: _ctx.ruleForm.details,
            border: "",
            fit: "",
            "row-key": "id",
            class: "fullWidth",
            "summary-method": _ctx.getSummaries,
            "show-summary": "",
            "header-cell-style": { background: '#ddd', color: 'rgba(0,0,0,0.9)' },
            onSelectionChange: _ctx.handleTableSelect
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "selection",
                width: "55"
              }),
              _createVNode(_component_el_table_column, {
                prop: "amount",
                label: "预购数量",
                width: "140"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_input, {
                    modelValue: row.amount,
                    "onUpdate:modelValue": ($event: any) => ((row.amount) = $event),
                    type: "number"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialNo",
                label: "物料编号",
                "show-overflow-tooltip": "",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialName",
                label: "名称",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "model",
                label: "型号",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialClass",
                label: "物料类别",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialUnit",
                label: "物料单位",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialStandard",
                label: "封装规格",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "max",
                label: "最高价",
                "show-overflow-tooltip": "",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.max)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        effect: "dark",
                        placement: "top-start"
                      }, {
                        content: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row.max?.supplier?.name), 1),
                          _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                          _createTextVNode(" 最后修改时间：" + _toDisplayString(scope.row.max?.updateTime), 1)
                        ]),
                        default: _withCtx(() => [
                          _cache[5] || (_cache[5] = _createElementVNode("i", {
                            class: "iconfont icon-tubiao-30",
                            style: {"font-size":"14px"}
                          }, null, -1))
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.maxMinCalc(scope.row, 'max')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "min",
                label: "最低价",
                "show-overflow-tooltip": "",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.min)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        effect: "dark",
                        placement: "top-start"
                      }, {
                        content: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row.min?.supplier?.name), 1),
                          _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                          _createTextVNode(" 最后修改时间：" + _toDisplayString(scope.row.min?.updateTime), 1)
                        ]),
                        default: _withCtx(() => [
                          _cache[7] || (_cache[7] = _createElementVNode("i", {
                            class: "iconfont icon-tubiao-30",
                            style: {"font-size":"14px"}
                          }, null, -1))
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.maxMinCalc(scope.row, 'min')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "summary-method", "onSelectionChange"])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules", "disabled"]),
    (_ctx.mode !== 'approval')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_el_button, { onClick: _ctx.cancle }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            loading: _ctx.submitLoading,
            onClick: _ctx.handleSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.dialogVisible)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 1,
          modelValue: _ctx.dialogVisible,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogVisible) = $event)),
          title: "物料列表",
          width: "80%",
          "before-close": () => _ctx.dialogVisible = false
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_el_button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogVisible = false))
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("取消", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.handleChoose
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode("确定", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_MaterialDialog, {
              ref: "MaterialDialog",
              excludeIds: _ctx.getexcludeIds()
            }, null, 8, ["excludeIds"])
          ]),
          _: 1
        }, 8, ["modelValue", "before-close"]))
      : _createCommentVNode("", true)
  ]))
}